import { FetchResult } from '@apollo/client'
import { ServiceDependencies } from 'lib/core/services/magento'
import { MagentoCustomerPaymentTokens } from 'lib/types'
import { apolloClient } from 'lib/core/services/magento/client'
import gql from 'graphql-tag'
import { jsonToGraphQLQuery } from 'lib/core/resources/helpers/jsonToGraphql'

export interface CustomerPaymentTokensQueryObject {
  customerPaymentTokens: {
    items: {
      details: true
      payment_method_code: true
      public_hash: true
      type: true
    }
  }
}

export const customerPaymentTokensQueryObject: CustomerPaymentTokensQueryObject = {
  customerPaymentTokens: {
    items: {
      details: true,
      payment_method_code: true,
      public_hash: true,
      type: true
    }
  }
}

export type GetCustomerPaymentTokensQuery = () => Promise<FetchResult<{ customerPaymentTokens: MagentoCustomerPaymentTokens }>>

export const createCustomerPaymentTokensQuery = ({ getQueries }: ServiceDependencies): GetCustomerPaymentTokensQuery => async () => {
  const query = getQueries().customerPaymentTokensQuery

  return apolloClient.query({
    query: gql`{${jsonToGraphQLQuery(query)}}`,
    fetchPolicy: 'no-cache'
  })
}
